import React from "react";

import MegaMenuCard from "../MegaMenuCard/MegaMenuCard";

import "./MegaMenuGrid.css";

const MegaMenuGrid = ({ menu }) => {
  const columns = Math.min(menu.sections.length, 4);
  return (
    <div
      className="school-mega-menu-grid"
      style={{
          "--menu-columns": columns,
      }}
    >
      {menu.sections.map((section) => (
        <MegaMenuCard
          key={section.id}
          section={section}
        />
      ))}
    </div>
  );
};

export default MegaMenuGrid;